/** Brain Learnings (AB#87286): propostas de melhoria do Brain que esperam decisão. */

import type { MemoryKind, MemoryScope } from "@/features/Memory/types/MemoryTypes";

export type LearningTarget = "memory" | "mind";
export type LearningAction = "create" | "update" | "delete" | "merge";
export type LearningStage = "origin" | "scope";
export type LearningStatus = "pending" | "accepted" | "rejected";
export type LearningOrigin = "review" | "external_agent" | "conversation";
export type LearningSignal =
  | "correction"
  | "repeated_question"
  | "decision"
  | "preference"
  | "unanswered"
  | "tool_error"
  | "duplicate"
  | "contradiction"
  | "unused"
  | "external_agent"
  | "inferred";
export type LearningFrequency = "daily" | "weekly";

/** `workspace`: a aba do Brain; `personal`: a do My view. */
export type LearningView = "workspace" | "personal";

/** Na tela: aprendidos (aplicados), sugestões da Mind (pendentes) e removidos. */
export const LEARNING_STATUSES: LearningStatus[] = ["accepted", "pending", "rejected"];

export interface Learning {
  id: string;
  product_id: string | null;
  target: LearningTarget;
  action: LearningAction;
  scope: MemoryScope | null;
  user_id: string | null;
  kind: MemoryKind | null;
  memory_ids: string[];
  mind_field_name: string | null;
  mind_title: string | null;
  before_content: string | null;
  content: string | null;
  rationale: string;
  cause: string | null;
  signal: LearningSignal;
  origin: LearningOrigin;
  agent: { client: string | null; connection: string | null } | null;
  stage: LearningStage;
  status: LearningStatus;
  reference_count: number;
  /** A proposta nasceu de uma conversa de quem está vendo. */
  from_me: boolean;
  /** Sugestão da Mind que este admin pode aplicar ou descartar. */
  can_decide: boolean;
  /** Aprendizado da Memory que esta pessoa pode remover (desfazer). */
  can_remove: boolean;
  created_at: string | null;
  decided_at: string | null;
}

export interface LearningReference {
  message_id: string;
  at: string;
  visible: boolean;
  text?: string;
}

export interface WorkspaceLearningSettings {
  enabled: boolean;
  frequency: LearningFrequency;
  last_run_at: string | null;
  reviewed_until: string | null;
  last_error: string | null;
}

export interface ReviewRunResult {
  messages: number;
  llmCalls: number;
  proposals: number;
  reviewedUntil: string | null;
}

export interface LearningsTarget {
  view: LearningView;
  productId?: string | null;
}
